/** 저가형(≈$0.01/run) — 무료 티어 허용 모델 (apps/web/src/lib/models.ts와 동기화) */
export const FREE_MODELS = [
    "claude-haiku",
    "gemini-flash",
    "deepseek-flash",
    "qwen397",
    "qwen27",
    "gemma-31b",
];
/** 고품질 — 유료/관리자 전용 모델 */
export const PAID_MODELS = [
    "claude-sonnet",
    "claude-opus",
    "gpt-5-codex",
    "kimi-k2",
    "glm-5",
    "minimax-m2",
];
export function modelsForRole(role) {
    return role === "free" ? [...FREE_MODELS] : [...FREE_MODELS, ...PAID_MODELS];
}
/** free → vercel-ai 스택 + FREE_MODELS 만. paid/admin → 전 러너 + 전 모델. */
export function isAllowed(role, runner, model) {
    if (role !== "free")
        return true;
    return runner === "vercel-ai" && FREE_MODELS.includes(model ?? "");
}
/** 생성 시점 role → 세션 가시성 */
export function visibilityForRole(role) {
    return role === "free" ? "public" : "private";
}
